import API from '../config/axiosConfig';

class AppService {
  static async getAllApps() {
    try {
      const response = await API.get('/api/apps');
      return response.data;
    } catch (error) {
      console.error('Error fetching apps:', error);
      throw error;
    }
  }

  // Public endpoint: `{ appToken, status }` for one app, with a null status when
  // no app owns the slug. App screens are reachable anonymously, so callers that
  // only need a status must use this and not getAllApps(), which requires a
  // logged-in user.
  static async getAppStatus(appToken) {
    const response = await API.get(
      `/api/apps/${encodeURIComponent(appToken)}/status`,
      { handlingErrorLocally: true }
    );
    return response.data?.status ?? null;
  }
}

export default AppService;